import { SettingService } from 'src/app/system-common/services/setting.service';
import { TabItem } from 'src/app/models/common/tab-items';
import { Component, OnInit, ViewChild } from '@angular/core';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { PageHeader } from 'src/app/models/common/page-header';
import { Subscription } from 'rxjs';
import { BaseService } from 'src/app/system-common/services/base.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { HttpClient } from '@angular/common/http';
import { CalendarOptions } from '@fullcalendar/core';

@Component({
  selector: 'sym-eonbording-landing-page',
  templateUrl: './eonboarding-landing-page.component.html',
  styleUrls: ['./eonboarding-landing-page.component.scss'],
})
export class EonboardingLandingPageComponent implements OnInit {
  tabList: TabItem[];
  selectedTab: TabItem;
  breadCrumbList: BreadCrumb[];
  widgetPreference: any[] = [];
  components: any[] = [];
  componentsContestIncentive: any[] = [];
  subs = new Subscription();
  public isContestPageShow: boolean;
  public isLeader: boolean;
  public userLoginData;
  public dashboardData: any;

  constructor(
    public headerService: HeaderService,
    public settingService: SettingService,
    public service: BaseService,
    protected http: HttpClient
  ) {
    this.isContestPageShow = true;
    this.isLeader = false;
    this.widgetPreference = [
      {
        dashboardTypeCd: 'ApplicationStatus',
      },
      {
        dashboardTypeCd: 'PerformanceStatus',
      },
    ];
  }

  ngOnInit() {
    this.settingService.removeSessionStorage('ApplicationStatus');
    this.settingService.removeSessionStorage('CheckerApplicationStatus');
    this.settingService.removeSessionStorage('AuditChanges');
    this.breadCrumbList = [];
    this.getPageHeader();
    this.userLoginData = undefined;
    if (sessionStorage.getItem('userLoginData') != undefined) {
      this.userLoginData = JSON.parse(sessionStorage.getItem('userLoginData'));
    }
    for (const role of this.userLoginData['userRoleList']) {
      if (role != 'AGENT') {
        this.isLeader = true;
        break;
      }
    }

    if (!this.isLeader) {
      this.widgetPreference = this.widgetPreference.filter(
        (item) => item.dashboardTypeCd !== 'ApplicationStatus' && item.dashboardTypeCd !== 'PerformanceStatus'
      );
    }
    this.tabList = this.getTabList();

    if (this.tabList[0] != undefined) {
      this.selectedTab = this.tabList[0];
      this.tabList[0].isSelected = true;
    }
    this.getDashboardPreferences().subscribe((res) => {
      let resData = JSON.parse(JSON.stringify(res));
      let componentOrder = resData?.data;
      componentOrder = {
        AgentApplicationStatusComponent: '5',
        AgentPerformanceComponent: '2',
        AgentPerformanceStatusComponent: '6',
        AgentProductionStatusComponent: '1',
        ContestGraph: '3',
        IncentiveGraph: '4',
        Promotion: '8',
        TeamPerformanceComponent: '7',
        EarningsComponent: '9',
      };
      this.components = Object.entries(componentOrder)
        .map(([label, order]) => ({ label, order: +order }))
        .sort((a, b) => a.order - b.order);
    });
  }

  private getPageHeader() {
    this.headerService.pageHeader = new PageHeader();
    this.headerService.pageHeader.title = 'Home';
  }

  protected getTabList(): TabItem[] {
    const tabs: TabItem[] = [
      {
        id: this.settingService.getLabelValue('applications'),
        isSelected: false,
        imageSrc: 'fas fa-file-alt',
      },
      {
        id: this.settingService.getLabelValue('recruitment'),
        isSelected: false,
        imageSrc: 'fas fa-user-plus',
      },
    ];

    return tabs;
  }

  public getDashboardPreferences() {
    let body = {
      agentId: this.userLoginData.agentId,
    };
    return this.service.httpPost('api/userdashboard/getDashboardPreferences', body);
  }

  public updateDashboardPreferences(body) {
    return this.http.post('api/userdashboard/dashboardPreference', body);
  }

  setTab(tab: TabItem) {
    this.selectedTab = tab;
  }

  dropChart(e: CdkDragDrop<any[]>) {
    moveItemInArray(this.components, e.previousIndex, e.currentIndex);
    const payload = {
      dashboardPreferences: this.components.map((comp, idx) => ({
        dashboardTypeCd: comp.label,
        position: String(idx + 1),
        isRequired: 'Y',
      })),
      agentId: this.userLoginData.agentId,
    };
    this.updateDashboardPreferences(payload).subscribe((res) => {});
  }

  trackByFn(index: number, comp: any) {
    return comp.label;
  }

  removeChart(chartLabel: string) {
    this.components = this.components.filter((c) => c.label !== chartLabel);
  }

  ngOnDestroy(): void {
    this.service.clear();
  }
}
